<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div
  class="text-area-container"
  [class.disabled]="disabled"
  [class.has-error]="hasError"
  [class.focused]="isFocused"
  >
  @if (label) {
    <label class="input-label">
      <hyperkit-typography variant="emphasized" size="sm" color="primary">
        {{ label }}
        @if (isRequired) {
          <span class="required-asterisk">*</span>
        }
      </hyperkit-typography>
    </label>
  }
  <div class="text-area-wrapper">
    <textarea
      [placeholder]="placeholder"
      [value]="value"
      [attr.maxlength]="maxlength"
      [disabled]="disabled"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      >
    </textarea>
  </div>
  @if (hint) {
    <div class="hint-container">
      <hyperkit-typography variant="body" size="sm" color="inherit">
        {{ hint }}
      </hyperkit-typography>
    </div>
  }
  @if (hasError) {
    <div class="hint-container">
      <hyperkit-error [error]="errorMessage"></hyperkit-error>
    </div>
  }
</div>
